
// 收货地址
const address = resolve => require(['../view/my/address'], resolve)
const addAddress = resolve => require(['../view/my/addAddress'], resolve)
//申请团长
const applynewGroupHead = resolve => require(['../view/my/applynewGroupHead'], resolve)
//申请单品代理
const applySingleAgent = resolve => require(['../view/agent/applySingleAgent'], resolve)
const applyPCAApply = resolve => require(['../view/agent/applyPCAApply'], resolve)
//申请全国厂家总店
const applyNFH = resolve => require(['../view/agent/applyNFH'], resolve)
const applyCitypar = resolve => require(['../view/agent/applyCitypar'], resolve)
const yundianpu = resolve => require(['../view/agent/yundianpu'], resolve)
const singleProList = resolve => require(['../view/agent/singleProList'], resolve)
const applyVouchers = resolve => require(['../view/agent/applyVouchers'], resolve)
const applyVIP = resolve => require(['../view/agent/applyVIP'], resolve)
//申请开店
const applyShop = resolve => require(['../view/agent/applyShop'], resolve)
// 申请零售云店铺
const applyLsydp = resolve => require(['../view/agent/applyLsydp'], resolve)
const borrow = resolve => require(['../view/agent/borrow'], resolve)

//申请流量补贴
const applyTrafficSubsidy = resolve => require(['../view/agent/applyTrafficSubsidy'], resolve)
//申请选货权
const applyChooseRight = resolve => require(['../view/agent/applyChooseRight'], resolve)
//选获权转让接口agentAuthorizedList
const agentAuthorized = resolve => require(['../view/agent/agentAuthorized'], resolve)
//选获权转让列表
const agentAuthorizedList = resolve => require(['../view/agent/agentAuthorizedList'], resolve)

const singleAgent = resolve => require(['../view/agent/single'], resolve)
const singleXuanhuo = resolve => require(['../view/agent/singleXuanhuo'], resolve)
const allshopXuanhuo = resolve => require(['../view/agent/allshopXuanhuo'], resolve)//我的总店选货
const forPTCOpen = resolve => require(['../view/agent/forPTCOpen'], resolve) //申请产品周转中心
const forHKQYAOpen = resolve => require(['../view/agent/forHKQYAOpen'], resolve) //惠康区域代理开通申请
const forBKAOpen = resolve => require(['../view/agent/forBKAOpen'], resolve) //版块代理申请开通
const ForPTAOpen = resolve => require(['../view/agent/ForPTAOpen'], resolve) //平台销售红包（平台代理）-开通
const ForCESOpenCS = resolve => require(['../view/agent/ForCESOpenCS'], resolve) //云端快递超市-开通云店铺接口
const ForPSSOpenHKYD = resolve => require(['../view/agent/ForPSSOpenHKYD'], resolve) //产品服务站-开通惠康云店接口
const ktqTurn = resolve => require(['../view/agent/ktqTurn'], resolve) //预开通权 和 开通权
const ForKtqApply = resolve => require(['../view/agent/ForKtqApply'], resolve) //开通权购买申请接口
const ForPAAOpen = resolve => require(['../view/agent/ForPAAOpen'], resolve)
const cloudStore = resolve => require(['../view/agent/cloudStore'], resolve)
const myshopShare = resolve => require(['../view/agent/myshopShare'], resolve)
const myCFMStore = resolve => require(['../view/agent/myCFMStore'], resolve)
const changeAgent = resolve => require(['../view/agent/changeAgent'], resolve)
const giftAgent = resolve => require(['../view/agent/giftAgent'], resolve)
const addAgent = resolve => require(['../view/agent/addAgent'], resolve)
const totalAgent = resolve => require(['../view/totalAgent/index'], resolve)
const choose = resolve => require(['../view/totalAgent/choose'], resolve)
const choose2 = resolve => require(['../view/totalAgent/choose2'], resolve)
const success = resolve => require(['../view/agent/success'], resolve)
const myxiaodian = resolve => require(['../view/agent/myxiaodian'], resolve)
const myshop = resolve => require(['../view/agent/myshop'], resolve)
const myallshop = resolve => require(['../view/agent/myallshop'], resolve)
const mycollect = resolve => require(['../view/my/mycollect'], resolve)
const pushShop = resolve => require(['../view/my/pushShop'], resolve)
const help = resolve => require(['../view/my/help'], resolve)
const shopIn = resolve => require(['../view/my/shopIn'], resolve)
const entityIn = resolve => require(['../view/my/entityIn'], resolve)
const exchange = resolve => require(['../view/my/exchange'], resolve)
const feedback = resolve => require(['../view/my/feedback'], resolve)
const setting = resolve => require(['../view/my/setting'], resolve)
const changeTel = resolve => require(['../view/my/changeTel'], resolve)
const changePwd = resolve => require(['../view/my/changePwd'], resolve)
const changeInfo = resolve => require(['../view/my/changeInfo'], resolve)
const message = resolve => require(['../view/my/message'], resolve)
const msgDetail = resolve => require(['../view/my/msgDetail'], resolve)
const invite = resolve => require(['../view/my/invite'], resolve)
const pay = resolve => require(['../view/my/pay'], resolve)
const aboutUs = resolve => require(['../view/my/aboutUs'], resolve)
const error = resolve => require(['../view/common/error'], resolve)
const kefu = resolve => require(['../view/my/kefu'], resolve)
const myMentor = resolve => require(['../view/my/myMentor'], resolve)
const setWeixin = resolve => require(['../view/my/setWeixin'], resolve)
const resetWeixin = resolve => require(['../view/my/resetWeixin'], resolve)
const bandOpenid = resolve => require(['../view/my/bandOpenid'], resolve)
const myshoperweima = resolve => require(['../view/my/myshoperweima'], resolve)
const payNum = resolve => require(['../view/my/payNum'], resolve)
//会员提现
const hyWithdraw = resolve => require(['../view/my/hyWithdraw'], resolve)
const registerList = resolve => require(['../view/my/registerList'], resolve)
const incomeList = resolve => require(['../view/my/incomeList'], resolve)
const giftList = resolve => require(['../view/agent/giftList'], resolve)
const PrizeList = resolve => require(['../view/agent/PrizeList'], resolve)
const giftSureSign = resolve => require(['../view/agent/giftSureSign'], resolve)
const PrizeListSureSign = resolve => require(['../view/agent/PrizeListSureSign'], resolve)
const travelList = resolve => require(['../view/agent/travelList'], resolve)
const cssaleLog = resolve => require(['../view/agent/cssaleLog'], resolve)

//银行卡号
const addBankcard = resolve => require(['../view/my/addBankcard'], resolve)
const myBankcard = resolve => require(['../view/my/myBankcard'], resolve)
const xzBankcard = resolve => require(['../view/my/xzBankcard'], resolve)
const delBankcard = resolve => require(['../view/my/delBankcard'], resolve)

//砍一刀
const kanyidao = resolve => require(['../view/my/kanyidao'], resolve)
const kanyidaolu = resolve => require(['../view/my/kanyidaolu'], resolve)



const routes = [
  {
    path: '/address',
    name: 'address',
    component: address,
    meta: {
      // requireAuth: true
    }
  },
  {
    path: '/addAddress',
    name: 'addAddress',
    component: addAddress,
    meta: {
      // requireAuth: true
    }
  },
  {
    path: '/applynewGroupHead',
    name: 'applynewGroupHead',
    component: applynewGroupHead,
    meta: {
      // requireAuth: true
    }
  },
  {
    path: '/applySingleAgent',
    name: 'applySingleAgent',
    component: applySingleAgent,
    meta: {
      // keepAlive: true
      // requireAuth: true
    }
  },
  {
    path: '/applyPCAApply',
    name: 'applyPCAApply',
    component: applyPCAApply,
    meta: {
      // keepAlive: true
      // requireAuth: true
    }
  },
  {
    path: '/applyNFH',
    name: 'applyNFH',
    component: applyNFH,
    meta: {
      // keepAlive: true
      // requireAuth: true
    }
  },
  {
    path: '/applyShop',
    name: 'applyShop',
    component: applyShop,
    meta: {
      // keepAlive: true
      // requireAuth: true
    }
  },
  {
    path: '/borrow',
    name: 'borrow',
    component: borrow,
    meta: {
      // keepAlive: true
      // requireAuth: true
    }
  },
  {
    path: '/applyCitypar',
    name: 'applyCitypar',
    component: applyCitypar,
    meta: {
      // keepAlive: true
      // requireAuth: true
    }
  },
  {
    path: '/applyVouchers',
    name: 'applyVouchers',
    component: applyVouchers,
    meta: {
      // keepAlive: true
      // requireAuth: true
    }
  },
  {
    path: '/applyVIP',
    name: 'applyVIP',
    component: applyVIP,
    meta: {
      // keepAlive: true
      // requireAuth: true
    }
  },
  {
    path: '/yundianpu',
    name: 'yundianpu',
    component: yundianpu,
    meta: {
      // keepAlive: true
      // requireAuth: true
    }
  },
  {
    path: '/singleProList',
    name: 'singleProList',
    component: singleProList,
    meta: {
      // keepAlive: true
      // requireAuth: true
    }
  },
  {
    path: '/applyTrafficSubsidy',
    name: 'applyTrafficSubsidy',
    component: applyTrafficSubsidy,
    meta: {
      // keepAlive: true
      // requireAuth: true
    }
  },
  {
    path: '/applyChooseRight',
    name: 'applyChooseRight',
    component: applyChooseRight,
    meta: {
      // keepAlive: true
      // requireAuth: true
    }
  },
  {
    path: '/agentAuthorized',
    name: 'agentAuthorized',
    component: agentAuthorized,
    meta: {
      // keepAlive: true
      // requireAuth: true
    }
  },
  {
    path: '/agentAuthorizedList',
    name: 'agentAuthorizedList',
    component: agentAuthorizedList,
    meta: {
      // keepAlive: true
      // requireAuth: true
    }
  },
  {
    path: '/singleAgent',
    name: 'singleAgent',
    component: singleAgent,
    meta: {
      keepAlive: true
      // requireAuth: true
    }
  },
  {
    path: '/forPTCOpen',
    name: 'forPTCOpen',
    component: forPTCOpen,
    meta: {
      // keepAlive: true
      // requireAuth: true
    }
  },
  {
    path: '/forHKQYAOpen',
    name: 'forHKQYAOpen',
    component: forHKQYAOpen,
    meta: {
      // keepAlive: true
      // requireAuth: true
    }
  },
  {
    path: '/ForPTAOpen',
    name: 'ForPTAOpen',
    component: ForPTAOpen,
    meta: {
      // keepAlive: true
      // requireAuth: true
    }
  },
  {
    path: '/ForPSSOpenHKYD',
    name: 'ForPSSOpenHKYD',
    component: ForPSSOpenHKYD,
    meta: {
      // keepAlive: true
      // requireAuth: true
    }
  },
  {
    path: '/ktqTurn',
    name: 'ktqTurn',
    component: ktqTurn,
    meta: {
      // keepAlive: true
      // requireAuth: true
    }
  },
  {
    path: '/ForKtqApply',
    name: 'ForKtqApply',
    component: ForKtqApply,
    meta: {
      // keepAlive: true
      // requireAuth: true
    }
  },
  {
    path: '/ForCESOpenCS',
    name: 'ForCESOpenCS',
    component: ForCESOpenCS,
    meta: {
      // keepAlive: true
      // requireAuth: true
    }
  },
  {
    path: '/ForPAAOpen',
    name: 'ForPAAOpen',
    component: ForPAAOpen,
    meta: {
      // keepAlive: true
      // requireAuth: true
    }
  },
  {
    path: '/forBKAOpen',
    name: 'forBKAOpen',
    component: forBKAOpen,
    meta: {
      // keepAlive: true
      // requireAuth: true
    }
  },
  {
    path: '/singleXuanhuo',
    name: 'singleXuanhuo',
    component: singleXuanhuo,
    meta: {
      // keepAlive: true
      // requireAuth: true
    }
  },
  {
    path: '/allshopXuanhuo',
    name: 'allshopXuanhuo',
    component: allshopXuanhuo,
    meta: {
      // keepAlive: true
      // requireAuth: true
    }
  },
  {
    path: '/cloudStore',
    name: 'cloudStore',
    component: cloudStore,
    meta: {
      keepAlive: true
      // requireAuth: true
    }
  },
  {
    path: '/applyLsydp',
    name: 'applyLsydp',
    component: applyLsydp,
    meta: {
      keepAlive: true
      // requireAuth: true
    }
  },
  {
    path: '/myshopShare',
    name: 'myshopShare',
    component: myshopShare,
    meta: {
      // keepAlive: true
      // requireAuth: true
    }
  },
  {
    path: '/myCFMStore',
    name: 'myCFMStore',
    component: myCFMStore,
    meta: {
      // keepAlive: true
      // requireAuth: true
    }
  },
  {
    path: '/changeAgent',
    name: 'changeAgent',
    component: changeAgent,
    meta: {
      keepAlive: true
      // requireAuth: true
    }
  },
  {
    path: '/giftAgent',
    name: 'giftAgent',
    component: giftAgent,
    meta: {
      // requireAuth: true
    }
  },
  {
    path: '/agent/success',
    name: 'success',
    component: success,
    meta: {
      // requireAuth: true
    }
  },
  {
    path: '/totalAgent',
    name: 'totalAgent',
    component: totalAgent,
    meta: {
      // requireAuth: true
    }
  },
{
    path: '/addAgent',
    name: 'addAgent',
    component: addAgent,
    meta: {
      // requireAuth: true
    }
  },
  {
    path: '/choose',
    name: 'choose',
    component: choose,
    meta: {
      // requireAuth: true
    }
  },
  {
    path: '/choose2',
    name: 'choose2',
    component: choose2,
    meta: {
      // requireAuth: true
    }
  },
  {
    path: '/myshop',
    name: 'myshop',
    component: myshop,
    meta: {
      keepAlive: true, // 判断该组件是否需要缓存
      // isBack: false // 判断是不是返回操作
      // requireAuth: true
    }
  },
  {
    path: '/myxiaodian',
    name: 'myxiaodian',
    component: myxiaodian,
    meta: {
      keepAlive: true, // 判断该组件是否需要缓存
      // isBack: false // 判断是不是返回操作
      // requireAuth: true
    }
  },
  {
    path: '/myallshop',
    name: 'myallshop',
    component: myallshop,
    meta: {
      // keepAlive: true, // 判断该组件是否需要缓存
      // isBack: false // 判断是不是返回操作
      // requireAuth: true
    }
  },
  {
    path: '/mycollect',
    name: 'mycollect',
    component: mycollect,
    meta: {
      // requireAuth: true
    }
  },
  {
    path: '/pushShop',
    name: 'pushShop',
    component: pushShop,
    meta: {
      // keepAlive: true
      // requireAuth: true
    }
  },
  {
    path: '/help',
    name: 'help',
    component: help,
    meta: {
      // requireAuth: true
    }
  },
  {
    path: '/shopIn',
    name: 'shopIn',
    component: shopIn,
    meta: {
      // requireAuth: true
    }
  },
  {
    path: '/entityIn',
    name: 'entityIn',
    component: entityIn,
    meta: {
      // requireAuth: true
    }
  },
  {
    path: '/exchange',
    name: 'exchange',
    component: exchange,
    meta: {
      // requireAuth: true
    }
  },
  {
    path: '/feedback',
    name: 'feedback',
    component: feedback,
    meta: {
      // requireAuth: true
    }
  },
  {
    path: '/setting',
    name: 'setting',
    component: setting,
    meta: {
      // requireAuth: true
    }
  },
  {
    path: '/changeTel',
    name: 'changeTel',
    component: changeTel,
    meta: {
      // requireAuth: true
    }
  },
  {
    path: '/changePwd',
    name: 'changePwd',
    component: changePwd,
    meta: {
      // requireAuth: true
    }
  },
  {
    path: '/changeInfo',
    name: 'changeInfo',
    component: changeInfo,
    meta: {
      // requireAuth: true
    }
  },
  {
    path: '/message',
    name: 'message',
    component: message,
    meta: {
      keepAlive: true,
      needLogin: true
      // requireAuth: true
    }
  },
  {
    path: '/msgDetail',
    name: 'msgDetail',
    component: msgDetail,
    meta: {
      // requireAuth: true
    }
  },
  {
    path: '/invite',
    name: 'invite',
    component: invite,
    meta: {
      // requireAuth: true
    }
  },
  {
    path: '/pay',
    name: 'pay',
    component: pay,
    meta: {
      // requireAuth: true
    }
  },
  {
    path: '/aboutUs',
    name: 'aboutUs',
    component: aboutUs,
    meta: {
      // requireAuth: true
    }
  },
  {
    path: '/kefu',
    name: 'kefu',
    component: kefu,
    meta: {
      // requireAuth: true
    }
  },
  {
    path: '/setWeixin',
    name: 'setWeixin',
    component: setWeixin,
    meta: {
      // requireAuth: true
    }
  },
  {
    path: '/resetWeixin',
    name: 'resetWeixin',
    component: resetWeixin,
    meta: {
      // requireAuth: true
    }
  },
  {
    path: '/bandOpenid',
    name: 'bandOpenid',
    component: bandOpenid,
    meta: {
      // requireAuth: true
    }
  },
  {
    path: '/myshoperweima',
    name: 'myshoperweima',
    component: myshoperweima,
    meta: {
      // requireAuth: true
    }
  },
  {
    path: '/payNum',
    name: 'payNum',
    component: payNum,
    meta: {
      // requireAuth: true
    }
  },
  {
    path: '/myMentor',
    name: 'myMentor',
    component: myMentor,
    meta: {
      // requireAuth: true
    }
  },
  {
    path: '/kanyidao',
    name: 'kanyidao',
    component: kanyidao,
    meta: {
      // requireAuth: true
    }
  },
  {
    path: '/kanyidaolu',
    name: 'kanyidaolu',
    component: kanyidaolu,
    meta: {
      // requireAuth: true
    }
  },
  {
    path: '/hyWithdraw',
    name: 'hyWithdraw',
    component: hyWithdraw,
    meta: {
      // requireAuth: true
    }
  },
  {
    path: '/incomeList',
    name: 'incomeList',
    component: incomeList,
    meta: {
      // requireAuth: true
    }
  },
  {
    path: '/giftList',
    name: 'giftList',
    component: giftList,
    meta: {
      // requireAuth: true
    }
  },
  {
    path: '/PrizeList',
    name: 'PrizeList',
    component: PrizeList,
    meta: {
      // requireAuth: true
    }
  },
  {
    path: '/travelList',
    name: 'travelList',
    component: travelList,
    meta: {
      // requireAuth: true
    }
  },
  {
    path: '/cssaleLog',
    name: 'cssaleLog',
    component: cssaleLog,
    meta: {
      // requireAuth: true
    }
  },
  {
    path: '/giftSureSign',
    name: 'giftSureSign',
    component: giftSureSign,
    meta: {
      // requireAuth: true
    }
  },
  {
    path: '/PrizeListSureSign',
    name: 'PrizeListSureSign',
    component: PrizeListSureSign,
    meta: {
      // requireAuth: true
    }
  },
  {
    path: '/addBankcard',
    name: 'addBankcard',
    component: addBankcard,
    meta: {
      // requireAuth: true
    }
  },
  {
    path: '/xzBankcard',
    name: 'xzBankcard',
    component: xzBankcard,
    meta: {
      // requireAuth: true
    }
  },
  {
    path: '/delBankcard',
    name: 'delBankcard',
    component: delBankcard,
    meta: {
      // requireAuth: true
    }
  },
  {
    path: '/myBankcard',
    name: 'myBankcard',
    component: myBankcard,
    meta: {
      // requireAuth: true
    }
  },
  {
    path: '/registerList',
    name: 'registerList',
    component: registerList,
    meta: {
      // requireAuth: true
    }
  }
]
export default {
  routes
}



// WEBPACK FOOTER //
// ./src/router/my.js